import { NumberService } from '@pbx/services/NumberService';

export const pbx_internal_number = {
  validate: async value => {
    try {
      const exist_numbers = await NumberService.getForScheme({ number: value });
      const is_exist = exist_numbers.some(f => f.number.toString() === value.toString());

      return !is_exist;
    } catch (e) {
      return false;
    }
  }
};
